
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { Plan, PlanWithJobRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class AddPlanWithJobUsecase implements UseCase<PlanWithJobRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanWithJobRequest): Observable<boolean> {
    return this.planRepository.addPlanWithJob(params);
  }

}